module.exports = __webpack_public_path__ + "img/churchplus-logo.0f18f2b3.png";